// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.leaf-icon {
  width: 25px;
  height: 25px;
  color: green;
  /* float: right; */
}

#main-table-wrapper td,
#main-table-wrapper th {
  border: none !important;
  border-bottom: 1px solid #eef1f6 !important;
  text-align: center;
  padding-top: 12px !important;
  padding-bottom: 12px !important;
}

#main-table-wrapper td.less-space-td {
  text-align: right;
  padding-right: 15px; /* Adds space so it doesn't touch the next column */
  width: 1% !important;
}
#main-table-wrapper th:nth-child(4) {
  width: 1%;
  white-space: nowrap;
}

#main-table-wrapper td.productName-text,
#main-table-wrapper th.item-name-grocery {
  text-align: left;
  width: 40%;
}

#main-table-wrapper th:nth-child(2),
#main-table-wrapper td:nth-child(2),
#main-table-wrapper th:nth-child(8),
#main-table-wrapper td:nth-child(8) {
  width: 1%;
  white-space: nowrap;
}

/* TYPE column – keep a guaranteed minimum so icons are never clipped */
#main-table-wrapper th:nth-child(1),
#main-table-wrapper td:nth-child(1) {
  min-width: 36px;
  width: 36px;
  white-space: nowrap;
  text-align: center;
}

.fw-bold {
  font-weight: 700 !important;
}


.grocery-table-type {
  text-align: center;
  min-width: 36px;
  width: 36px;
  overflow: visible;
}

.offer-marking {
  vertical-align: middle;
  font-size: 1rem !important;
  margin-right: 5px;
  color: rgb(23, 240, 33);
}

.no-offer-marking {
  vertical-align: middle;
  font-size: 1rem !important;
  margin-right: 5px;
  color: rgb(253, 15, 15);
}

.inner-td-content {
  white-space: normal;
  width: 100%;
  overflow: hidden;
  line-height: 1.5em;
  max-height: 3em; /* 1.5em * 2 lines */
}

.expired-row {
  background-color: #fff3f3 !important;
}

.combo-badge {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  padding: 2px 6px;
  font-size: 11px;
  font-weight: 600;
  color: #7c3aed;
  background-color: #ede9fe;
  border: 1px solid #c4b5fd;
  border-radius: 4px;
  margin-left: 8px;
}

.expired-badge {
  display: inline-flex;
  align-items: center;
  padding: 2px 6px;
  font-size: 11px;
  font-weight: 600;
  color: #dc3545;
  background-color: #ffe5e5;
  border: 1px solid #ffcccc;
  border-radius: 4px;
  margin-left: 8px;
}

/* ── Oversold badge ─────────────────────────────────────────────────────────── */
.oversold-badge {
  display: inline-flex;
  align-items: center;
  padding: 2px 6px;
  font-size: 11px;
  font-weight: 600;
  color: #92400e;
  background-color: #fef3c7;
  border: 1px solid #fcd34d;
  border-radius: 4px;
  margin-left: 8px;
  cursor: default;
  white-space: nowrap;
}

.dark .oversold-badge {
  color: #fde68a;
  background-color: rgba(217, 119, 6, 0.2);
  border-color: rgba(217, 119, 6, 0.5);
}
/* ─────────────────────────────────────────────────────────────────────────── */

.product-name-wrapper {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: wrap;
}

/* ─── STEPPER FIX ────────────────────────────────────────────────────────────
   REMOVED overflow: hidden — it was clipping the buttons and blocking pointer
   events + click registration on the rounded ends of the pill.
   Border-radius is now applied directly to the first/last child buttons
   instead, so the pill shape is preserved without the clipping side-effect.
────────────────────────────────────────────────────────────────────────────── */
.qty-stepper-wrapper {
  display: flex;
  width: 100%;
  align-items: center;
  border: 1px solid #d9d9d9;
  border-radius: 999px;
  box-shadow:
    0 1px 3px 0 #0000001a,
    0 1px 2px -1px #0000001a;
}

.qty-stepper-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  background: transparent;
  border: none;
  cursor: pointer !important; /* force pointer — parent table styles can override */
  font-size: 18px;
  font-weight: 500;
  color: #333;
  padding: 0;
  line-height: 1;
  flex-shrink: 0;
  transition: background 0.15s;
  position: relative; /* ensures z-index stacking above table borders */
  z-index: 1;
  user-select: none; /* prevents accidental text selection on fast clicks */
  -webkit-user-select: none;
  pointer-events: auto !important; /* override any inherited pointer-events: none */
}

/* Round only the outer edges of the pill buttons, not the inner edges */
.qty-stepper-btn--minus {
  border-radius: 999px 0 0 999px;
}

.qty-stepper-btn--minus:hover {
  background-color: #f8fafc;
}

.qty-stepper-btn--plus {
  border-radius: 0 999px 999px 0;
}

.qty-stepper-btn--plus:hover {
  background-color: #f8fafc;
}

.qty-stepper-btn:hover {
  background: #e8e8e8;
  cursor: pointer !important;
}

.qty-stepper-btn:active {
  background: #d5d5d5;
}

/* Hide native number-input spin arrows inside the stepper */
.qty-stepper-input::-webkit-inner-spin-button,
.qty-stepper-input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.qty-stepper-input {
  -moz-appearance: textfield;
}

.qty-stepper-input {
  flex: 1;
  width: 100%;
  min-width: 36px;
  text-align: center;
  border: none !important;
  border-left: 1px solid #d9d9d9 !important;
  border-right: 1px solid #d9d9d9 !important;
  border-radius: 0 !important;
  background: #fff;
  font-size: 13px;
  font-weight: 500;
  height: 28px;
  padding: 0 4px;
  outline: none;
  box-shadow: none !important;
  cursor: text;
}

.grocery-table-weight {
  background-color: #eff6ff;
  border-radius: 50%;
  height: 20px;
  width: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
}

.sp-input {
  text-align: center;
  padding: 0;
  margin: 0 auto;
  -moz-appearance: textfield;
}

.sp-input::-webkit-outer-spin-button,
.sp-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.mrp-space-td form {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin: 0;
}

#main-table-wrapper th:nth-child(7),
#main-table-wrapper td:nth-child(7) {
  width: calc(8ch + 5px); /* 8 chars + 5px padding on each side */
  min-width: calc(8ch + 5px);
  max-width: calc(8ch + 5px);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

#main-table-wrapper td:nth-child(2),
/* #main-table-wrapper td:nth-child(5), */
#main-table-wrapper td:nth-child(7),
#main-table-wrapper td:nth-child(9),
#main-table-wrapper td:nth-child(10) {
  font-weight: 400 !important;
  color: #6b7280 !important;
}

/* MRP column (td:nth-child(5)) sits in the nth-child reset list above.
   Two-class selector (1,2,1) beats the nth-child selector (1,1,1) regardless of order. */
#main-table-wrapper td.mrp-space-td.fw-bold {
  font-weight: 700 !important;
  color: #111827 !important;
}

/* Barcode container: label muted, value bold */
.product-barcode-text {
  font-size: 0.8rem;
  font-weight: 400;
  color: #9ca3af;
}
.barcode-value {
  font-weight: 700 !important;
  color: #374151 !important;
}

.grocery-barcode-container {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 2px;
}

.grocery-offer-chip {
  display: flex;
  align-items: center;
  gap: 4px;
  background-color: #fffbeb;
  border-radius: 50px;
  padding: 3px 12px;
}

.product-offer-text {
  font-weight: 600;
  color: #bb4d00;
  font-size: 0.625rem;
  letter-spacing: 0.12rem;
}

/* Cart item highlight animation for table rows */
@keyframes cartItemTableHighlightAnimation {
  0% {
    background-color: var(--Blue-B4, #d9f2ff);
  }
  50% {
    background-color: #b3e0ff;
  }
  100% {
    background-color: var(--Blue-B4, #d9f2ff);
  }
}

@keyframes cartItemTableHighlightAnimationDark {
  0% {
    background-color: rgba(8, 96, 230, 0.3);
  }
  50% {
    background-color: rgba(8, 96, 230, 0.45);
  }
  100% {
    background-color: rgba(8, 96, 230, 0.3);
  }
}

/* Flash animation class */
#myDiv3.cartItemTableFlash,
#myFocusDiv.cartItemTableFlash,
tr.cartItemTableFlash {
  animation: cartItemTableHighlightAnimation 0.5s ease-in-out 2;
  background-color: var(--Blue-B4, #d9f2ff) !important;
}

.dark #myDiv3.cartItemTableFlash,
.dark #myFocusDiv.cartItemTableFlash,
.dark tr.cartItemTableFlash {
  animation: cartItemTableHighlightAnimationDark 0.5s ease-in-out 2;
  background-color: rgba(8, 96, 230, 0.3) !important;
}

/* Persistent top row highlight class */
#myDiv3.cartItemTableTopHighlight,
#myFocusDiv.cartItemTableTopHighlight,
tr.cartItemTableTopHighlight {
  background-color: var(--Blue-B4, #d9f2ff) !important;
}

.dark #myDiv3.cartItemTableTopHighlight,
.dark #myFocusDiv.cartItemTableTopHighlight,
.dark tr.cartItemTableTopHighlight {
  background-color: rgba(8, 96, 230, 0.3) !important;
}

/* Focused row states – matches the blue top-row highlight */
#main-table-wrapper #myDiv3:focus,
#main-table-wrapper #myFocusDiv:focus,
#main-table-wrapper tr:focus,
#main-table-wrapper #myDiv3:focus-within,
#main-table-wrapper #myFocusDiv:focus-within,
#main-table-wrapper tr:focus-within {
  background-color: var(--Blue-B4, #d9f2ff) !important;
  color: #000 !important;
}

#main-table-wrapper #myDiv3:focus td,
#main-table-wrapper #myFocusDiv:focus td,
#main-table-wrapper tr:focus td,
#main-table-wrapper #myDiv3:focus-within td,
#main-table-wrapper #myFocusDiv:focus-within td,
#main-table-wrapper tr:focus-within td {
  color: #000 !important;
}

.dark #main-table-wrapper #myDiv3:focus,
.dark #main-table-wrapper #myFocusDiv:focus,
.dark #main-table-wrapper tr:focus,
.dark #main-table-wrapper #myDiv3:focus-within,
.dark #main-table-wrapper #myFocusDiv:focus-within,
.dark #main-table-wrapper tr:focus-within {
  background-color: rgba(8, 96, 230, 0.3) !important;
}

/* Total column layout with Trash delete icon */
#main-table-wrapper th:last-child {
  padding-right: 32px !important;
  min-width: 100px;
}

.total-column-cell {
  position: relative;
  padding-right: 32px !important;
  min-width: 100px;
}

.total-column-cell .trash-delete-icon {
  position: absolute;
  right: 6px;
  top: 50%;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  color: #ef4444;
  cursor: pointer;
  transition: color 0.2s;
}

.total-column-cell .trash-delete-icon:hover {
  color: #dc2626;
}

.bundle-icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  margin: 0 auto;
}

.bundle-icon-bg {
  display: flex;
  height: 1.5rem;
  width: 1.5rem;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  background-color: #fef3c7;
  color: #d97706;
  flex-shrink: 0;
}

.bundle-svg {
  height: 1rem;
  width: 1rem;
}

/* dark mode overrides for bundle icon */
.dark .bundle-icon-bg {
  background-color: rgba(217, 119, 6, 0.2);
  color: #fbbf24;
}

/* ── Offer icon (flame) in TYPE column ── */
.offer-icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  margin: 0 auto;
}

.offer-icon-bg {
  display: flex;
  height: 1.5rem;
  width: 1.5rem;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  background-color: #fff7ed;
  color: #ea580c;
  flex-shrink: 0;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/all-products/components/cartItemTable/CartItemTable.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;EAEE,uBAAuB;EACvB,2CAA2C;EAC3C,kBAAkB;EAClB,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB,EAAE,mDAAmD;EACxE,oBAAoB;AACtB;AACA;EACE,SAAS;EACT,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;;;;EAIE,SAAS;EACT,mBAAmB;AACrB;;AAEA,uEAAuE;AACvE;;EAEE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;;AAGA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,eAAe,EAAE,oBAAoB;AACvC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,kFAAkF;AAClF;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,oCAAoC;AACtC;AACA,gFAAgF;;AAEhF;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;;;;;gFAKgF;AAChF;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;EACpB;;4BAE0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,0BAA0B,EAAE,qDAAqD;EACjF,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,UAAU;EACV,cAAc;EACd,cAAc;EACd,4BAA4B;EAC5B,kBAAkB,EAAE,iDAAiD;EACrE,UAAU;EACV,iBAAiB,EAAE,sDAAsD;EACzE,yBAAyB;EACzB,+BAA+B,EAAE,gDAAgD;AACnF;;AAEA,wEAAwE;AACxE;EACE,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,4DAA4D;AAC5D;;EAEE,wBAAwB;EACxB,SAAS;AACX;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,OAAO;EACP,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,uBAAuB;EACvB,yCAAyC;EACzC,0CAA0C;EAC1C,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,aAAa;EACb,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,0BAA0B;AAC5B;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,SAAS;AACX;;AAEA;;EAEE,sBAAsB,EAAE,uCAAuC;EAC/D,0BAA0B;EAC1B,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;;;;EAKE,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;yFACyF;AACzF;EACE,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA,+CAA+C;AAC/C;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,iDAAiD;AACjD;EACE;IACE,yCAAyC;EAC3C;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yCAAyC;EAC3C;AACF;;AAEA;EACE;IACE,uCAAuC;EACzC;EACA;IACE,wCAAwC;EAC1C;EACA;IACE,uCAAuC;EACzC;AACF;;AAEA,0BAA0B;AAC1B;;;EAGE,6DAA6D;EAC7D,oDAAoD;AACtD;;AAEA;;;EAGE,iEAAiE;EACjE,kDAAkD;AACpD;;AAEA,uCAAuC;AACvC;;;EAGE,oDAAoD;AACtD;;AAEA;;;EAGE,kDAAkD;AACpD;;AAEA,4DAA4D;AAC5D;;;;;;EAME,oDAAoD;EACpD,sBAAsB;AACxB;;AAEA;;;;;;EAME,sBAAsB;AACxB;;AAEA;;;;;;EAME,kDAAkD;AACpD;;AAEA,+CAA+C;AAC/C;EACE,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,cAAc;EACd,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA,wCAAwC;AACxC;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA,4CAA4C;AAC5C;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,cAAc;AAChB","sourcesContent":[".leaf-icon {\n  width: 25px;\n  height: 25px;\n  color: green;\n  /* float: right; */\n}\n\n#main-table-wrapper td,\n#main-table-wrapper th {\n  border: none !important;\n  border-bottom: 1px solid #eef1f6 !important;\n  text-align: center;\n  padding-top: 12px !important;\n  padding-bottom: 12px !important;\n}\n\n#main-table-wrapper td.less-space-td {\n  text-align: right;\n  padding-right: 15px; /* Adds space so it doesn't touch the next column */\n  width: 1% !important;\n}\n#main-table-wrapper th:nth-child(4) {\n  width: 1%;\n  white-space: nowrap;\n}\n\n#main-table-wrapper td.productName-text,\n#main-table-wrapper th.item-name-grocery {\n  text-align: left;\n  width: 40%;\n}\n\n#main-table-wrapper th:nth-child(2),\n#main-table-wrapper td:nth-child(2),\n#main-table-wrapper th:nth-child(8),\n#main-table-wrapper td:nth-child(8) {\n  width: 1%;\n  white-space: nowrap;\n}\n\n/* TYPE column – keep a guaranteed minimum so icons are never clipped */\n#main-table-wrapper th:nth-child(1),\n#main-table-wrapper td:nth-child(1) {\n  min-width: 36px;\n  width: 36px;\n  white-space: nowrap;\n  text-align: center;\n}\n\n.fw-bold {\n  font-weight: 700 !important;\n}\n\n\n.grocery-table-type {\n  text-align: center;\n  min-width: 36px;\n  width: 36px;\n  overflow: visible;\n}\n\n.offer-marking {\n  vertical-align: middle;\n  font-size: 1rem !important;\n  margin-right: 5px;\n  color: rgb(23, 240, 33);\n}\n\n.no-offer-marking {\n  vertical-align: middle;\n  font-size: 1rem !important;\n  margin-right: 5px;\n  color: rgb(253, 15, 15);\n}\n\n.inner-td-content {\n  white-space: normal;\n  width: 100%;\n  overflow: hidden;\n  line-height: 1.5em;\n  max-height: 3em; /* 1.5em * 2 lines */\n}\n\n.expired-row {\n  background-color: #fff3f3 !important;\n}\n\n.combo-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n  padding: 2px 6px;\n  font-size: 11px;\n  font-weight: 600;\n  color: #7c3aed;\n  background-color: #ede9fe;\n  border: 1px solid #c4b5fd;\n  border-radius: 4px;\n  margin-left: 8px;\n}\n\n.expired-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 6px;\n  font-size: 11px;\n  font-weight: 600;\n  color: #dc3545;\n  background-color: #ffe5e5;\n  border: 1px solid #ffcccc;\n  border-radius: 4px;\n  margin-left: 8px;\n}\n\n/* ── Oversold badge ─────────────────────────────────────────────────────────── */\n.oversold-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 6px;\n  font-size: 11px;\n  font-weight: 600;\n  color: #92400e;\n  background-color: #fef3c7;\n  border: 1px solid #fcd34d;\n  border-radius: 4px;\n  margin-left: 8px;\n  cursor: default;\n  white-space: nowrap;\n}\n\n.dark .oversold-badge {\n  color: #fde68a;\n  background-color: rgba(217, 119, 6, 0.2);\n  border-color: rgba(217, 119, 6, 0.5);\n}\n/* ─────────────────────────────────────────────────────────────────────────── */\n\n.product-name-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  flex-wrap: wrap;\n}\n\n/* ─── STEPPER FIX ────────────────────────────────────────────────────────────\n   REMOVED overflow: hidden — it was clipping the buttons and blocking pointer\n   events + click registration on the rounded ends of the pill.\n   Border-radius is now applied directly to the first/last child buttons\n   instead, so the pill shape is preserved without the clipping side-effect.\n────────────────────────────────────────────────────────────────────────────── */\n.qty-stepper-wrapper {\n  display: flex;\n  width: 100%;\n  align-items: center;\n  border: 1px solid #d9d9d9;\n  border-radius: 999px;\n  box-shadow:\n    0 1px 3px 0 #0000001a,\n    0 1px 2px -1px #0000001a;\n}\n\n.qty-stepper-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  background: transparent;\n  border: none;\n  cursor: pointer !important; /* force pointer — parent table styles can override */\n  font-size: 18px;\n  font-weight: 500;\n  color: #333;\n  padding: 0;\n  line-height: 1;\n  flex-shrink: 0;\n  transition: background 0.15s;\n  position: relative; /* ensures z-index stacking above table borders */\n  z-index: 1;\n  user-select: none; /* prevents accidental text selection on fast clicks */\n  -webkit-user-select: none;\n  pointer-events: auto !important; /* override any inherited pointer-events: none */\n}\n\n/* Round only the outer edges of the pill buttons, not the inner edges */\n.qty-stepper-btn--minus {\n  border-radius: 999px 0 0 999px;\n}\n\n.qty-stepper-btn--minus:hover {\n  background-color: #f8fafc;\n}\n\n.qty-stepper-btn--plus {\n  border-radius: 0 999px 999px 0;\n}\n\n.qty-stepper-btn--plus:hover {\n  background-color: #f8fafc;\n}\n\n.qty-stepper-btn:hover {\n  background: #e8e8e8;\n  cursor: pointer !important;\n}\n\n.qty-stepper-btn:active {\n  background: #d5d5d5;\n}\n\n/* Hide native number-input spin arrows inside the stepper */\n.qty-stepper-input::-webkit-inner-spin-button,\n.qty-stepper-input::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n.qty-stepper-input {\n  -moz-appearance: textfield;\n}\n\n.qty-stepper-input {\n  flex: 1;\n  width: 100%;\n  min-width: 36px;\n  text-align: center;\n  border: none !important;\n  border-left: 1px solid #d9d9d9 !important;\n  border-right: 1px solid #d9d9d9 !important;\n  border-radius: 0 !important;\n  background: #fff;\n  font-size: 13px;\n  font-weight: 500;\n  height: 28px;\n  padding: 0 4px;\n  outline: none;\n  box-shadow: none !important;\n  cursor: text;\n}\n\n.grocery-table-weight {\n  background-color: #eff6ff;\n  border-radius: 50%;\n  height: 20px;\n  width: 20px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto;\n}\n\n.sp-input {\n  text-align: center;\n  padding: 0;\n  margin: 0 auto;\n  -moz-appearance: textfield;\n}\n\n.sp-input::-webkit-outer-spin-button,\n.sp-input::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n.mrp-space-td form {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  margin: 0;\n}\n\n#main-table-wrapper th:nth-child(7),\n#main-table-wrapper td:nth-child(7) {\n  width: calc(8ch + 5px); /* 8 chars + 5px padding on each side */\n  min-width: calc(8ch + 5px);\n  max-width: calc(8ch + 5px);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n#main-table-wrapper td:nth-child(2),\n/* #main-table-wrapper td:nth-child(5), */\n#main-table-wrapper td:nth-child(7),\n#main-table-wrapper td:nth-child(9),\n#main-table-wrapper td:nth-child(10) {\n  font-weight: 400 !important;\n  color: #6b7280 !important;\n}\n\n/* MRP column (td:nth-child(5)) sits in the nth-child reset list above.\n   Two-class selector (1,2,1) beats the nth-child selector (1,1,1) regardless of order. */\n#main-table-wrapper td.mrp-space-td.fw-bold {\n  font-weight: 700 !important;\n  color: #111827 !important;\n}\n\n/* Barcode container: label muted, value bold */\n.product-barcode-text {\n  font-size: 0.8rem;\n  font-weight: 400;\n  color: #9ca3af;\n}\n.barcode-value {\n  font-weight: 700 !important;\n  color: #374151 !important;\n}\n\n.grocery-barcode-container {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 2px;\n}\n\n.grocery-offer-chip {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  background-color: #fffbeb;\n  border-radius: 50px;\n  padding: 3px 12px;\n}\n\n.product-offer-text {\n  font-weight: 600;\n  color: #bb4d00;\n  font-size: 0.625rem;\n  letter-spacing: 0.12rem;\n}\n\n/* Cart item highlight animation for table rows */\n@keyframes cartItemTableHighlightAnimation {\n  0% {\n    background-color: var(--Blue-B4, #d9f2ff);\n  }\n  50% {\n    background-color: #b3e0ff;\n  }\n  100% {\n    background-color: var(--Blue-B4, #d9f2ff);\n  }\n}\n\n@keyframes cartItemTableHighlightAnimationDark {\n  0% {\n    background-color: rgba(8, 96, 230, 0.3);\n  }\n  50% {\n    background-color: rgba(8, 96, 230, 0.45);\n  }\n  100% {\n    background-color: rgba(8, 96, 230, 0.3);\n  }\n}\n\n/* Flash animation class */\n#myDiv3.cartItemTableFlash,\n#myFocusDiv.cartItemTableFlash,\ntr.cartItemTableFlash {\n  animation: cartItemTableHighlightAnimation 0.5s ease-in-out 2;\n  background-color: var(--Blue-B4, #d9f2ff) !important;\n}\n\n.dark #myDiv3.cartItemTableFlash,\n.dark #myFocusDiv.cartItemTableFlash,\n.dark tr.cartItemTableFlash {\n  animation: cartItemTableHighlightAnimationDark 0.5s ease-in-out 2;\n  background-color: rgba(8, 96, 230, 0.3) !important;\n}\n\n/* Persistent top row highlight class */\n#myDiv3.cartItemTableTopHighlight,\n#myFocusDiv.cartItemTableTopHighlight,\ntr.cartItemTableTopHighlight {\n  background-color: var(--Blue-B4, #d9f2ff) !important;\n}\n\n.dark #myDiv3.cartItemTableTopHighlight,\n.dark #myFocusDiv.cartItemTableTopHighlight,\n.dark tr.cartItemTableTopHighlight {\n  background-color: rgba(8, 96, 230, 0.3) !important;\n}\n\n/* Focused row states – matches the blue top-row highlight */\n#main-table-wrapper #myDiv3:focus,\n#main-table-wrapper #myFocusDiv:focus,\n#main-table-wrapper tr:focus,\n#main-table-wrapper #myDiv3:focus-within,\n#main-table-wrapper #myFocusDiv:focus-within,\n#main-table-wrapper tr:focus-within {\n  background-color: var(--Blue-B4, #d9f2ff) !important;\n  color: #000 !important;\n}\n\n#main-table-wrapper #myDiv3:focus td,\n#main-table-wrapper #myFocusDiv:focus td,\n#main-table-wrapper tr:focus td,\n#main-table-wrapper #myDiv3:focus-within td,\n#main-table-wrapper #myFocusDiv:focus-within td,\n#main-table-wrapper tr:focus-within td {\n  color: #000 !important;\n}\n\n.dark #main-table-wrapper #myDiv3:focus,\n.dark #main-table-wrapper #myFocusDiv:focus,\n.dark #main-table-wrapper tr:focus,\n.dark #main-table-wrapper #myDiv3:focus-within,\n.dark #main-table-wrapper #myFocusDiv:focus-within,\n.dark #main-table-wrapper tr:focus-within {\n  background-color: rgba(8, 96, 230, 0.3) !important;\n}\n\n/* Total column layout with Trash delete icon */\n#main-table-wrapper th:last-child {\n  padding-right: 32px !important;\n  min-width: 100px;\n}\n\n.total-column-cell {\n  position: relative;\n  padding-right: 32px !important;\n  min-width: 100px;\n}\n\n.total-column-cell .trash-delete-icon {\n  position: absolute;\n  right: 6px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 20px;\n  height: 20px;\n  color: #ef4444;\n  cursor: pointer;\n  transition: color 0.2s;\n}\n\n.total-column-cell .trash-delete-icon:hover {\n  color: #dc2626;\n}\n\n.bundle-icon-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  margin: 0 auto;\n}\n\n.bundle-icon-bg {\n  display: flex;\n  height: 1.5rem;\n  width: 1.5rem;\n  align-items: center;\n  justify-content: center;\n  border-radius: 9999px;\n  background-color: #fef3c7;\n  color: #d97706;\n  flex-shrink: 0;\n}\n\n.bundle-svg {\n  height: 1rem;\n  width: 1rem;\n}\n\n/* dark mode overrides for bundle icon */\n.dark .bundle-icon-bg {\n  background-color: rgba(217, 119, 6, 0.2);\n  color: #fbbf24;\n}\n\n/* ── Offer icon (flame) in TYPE column ── */\n.offer-icon-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  margin: 0 auto;\n}\n\n.offer-icon-bg {\n  display: flex;\n  height: 1.5rem;\n  width: 1.5rem;\n  align-items: center;\n  justify-content: center;\n  border-radius: 9999px;\n  background-color: #fff7ed;\n  color: #ea580c;\n  flex-shrink: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
